// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DomEl$GameDataCore from "../DomEl.res.mjs";

function syncIndeterminate(element) {
  var indeterminate = DomEl$GameDataCore.data(element, "indeterminate") === "true";
  element.indeterminate = indeterminate;
}

function mounted() {
  var self = this ;
  var update = function () {
    syncIndeterminate(self.el);
  };
  self.updateIndeterminate = update;
  syncIndeterminate(self.el);
}

function updated() {
  var self = this ;
  self.updateIndeterminate();
}

var SelectAllHeader = {
  mounted: mounted,
  updated: updated
};

export {
  syncIndeterminate ,
  mounted ,
  updated ,
  SelectAllHeader ,
}
/* mounted Not a pure module */
